module.exports = __webpack_public_path__ + "static/media/SIlent-auction.03e9962b.png";